import { MAX_FILTER_ITEMS, MAX_SEARCH_LENGTH } from './consts';
import getFilterCount from './getFilterCount';
import getSearchCount from './getSearchCount';

const getIsValidSearchText = (panelSearch) => {
  if (panelSearch.length > MAX_SEARCH_LENGTH || panelSearch.length === 0) {
    return false;
  }

  return true;
};

const getIsValidFilter = ({ createdBy, updatedBy }) => {
  if (
    createdBy?.length > MAX_FILTER_ITEMS ||
    updatedBy?.length > MAX_FILTER_ITEMS
  ) {
    return false;
  }

  return true;
};

const getIsValidSearchFilter = ({ panelSearch, panelFilters }) => {
  const searchCount = getSearchCount(panelSearch);
  const filterCount = getFilterCount(panelFilters);

  if (
    searchCount + filterCount === 0 ||
    (searchCount > 0 && !getIsValidSearchText(panelSearch)) ||
    (filterCount > 0 && !getIsValidFilter(panelFilters))
  ) {
    return false;
  }

  return true;
};

export default getIsValidSearchFilter;
